import React, { useEffect } from 'react';
import _ from 'lodash';
import { getSettingInputComponent } from './settings-component-factory';
import { Flex } from 'components/base/layout-components';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { SETTING_NAMES } from 'common/constants/constants';
import ReleaseDetectionSettings from './components/ReleaseDetectionSettings';
import ReleaseDetectionSettingsFFOff from './components/ReleaseDetectionSettingsFFOff';
import { FEATURE_FLAGS_NAMES, SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import PmIssueTagsFetchStrategy from './components/PmIssueTagsFetchStrategy';

const RELEASES_STRATEGY_REPORTED = 'reported';

const Settings = ({
  settings,
  entityId,
  entityType,
  onMount = _.noop,
  apiTokens,
  setApiTokens,
  toggleModal
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const bindSettingNameToFFs = {
    // [SettingName]: ffName
  };
  const filterSettingByFF = ({ name }) =>
    bindSettingNameToFFs.hasOwnProperty(name)
      ? !!getSettingOrDefinitionValue({
          name: bindSettingNameToFFs[name]
        })
      : true;

  const isCustomRelease = !!getSettingOrDefinitionValue({
    name: SETTING_NAMES.RELEASE_STAGES
  });

  useEffect(() => {
    if (onMount) {
      onMount();
    }
  }, []);

  const releaseDetectionSettingValue = getSettingOrDefinitionValue({
    name: SettingValues.RELEASES_STRATEGY,
    repositoryId: entityId,
    definitionLevel: entityType
  });
  const releaseDetectionSetting = settings.find(
    item => item.name === SettingValues.RELEASES_STRATEGY
  );

  const isApiTokensEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.apiTokens
  });

  const isPmIssueTagsFetchStrategyEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isPmIssueTagsFetchStrategyEnabled
  });

  const isPMToolsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isPMToolsEnabled
  });

  const codingTimeStrategy = getSettingOrDefinitionValue({
    name: SettingValues.CODING_TIME_STRATEGY
  });

  const getIsSettingDisabled = setting => {
    switch (setting.name) {
      case SettingValues.ISSUE_IN_PROGRESS_TRANSITION_STRATEGY:
        return _.get(codingTimeStrategy, 'key') === 'first_commit';
      case SettingValues.CODING_TIME_STRATEGY:
        return isPMToolsEnabled === false;
      default:
        return false;
    }
  };
  return (
    <Flex direction='column'>
      {releaseDetectionSetting &&
        ((isApiTokensEnabled && (
          <ReleaseDetectionSettings
            value={releaseDetectionSettingValue}
            apiTokens={apiTokens}
            setApiTokens={setApiTokens}
            definitionId={releaseDetectionSetting.definitionId}
            id={releaseDetectionSetting.id}
            definitionLevel={releaseDetectionSetting.definitionLevel}
            entityId={entityId}
            entityType={entityType}
            toggleModal={toggleModal}
            isApiTokensEnabled={isApiTokensEnabled}
            isReportedRelease={
              releaseDetectionSetting.name ===
                SettingValues.RELEASES_STRATEGY &&
              (_.get(releaseDetectionSetting, 'value.key') ===
                RELEASES_STRATEGY_REPORTED ||
                isCustomRelease)
            }
          />
        )) || (
          <ReleaseDetectionSettingsFFOff
            value={releaseDetectionSetting.value}
            apiTokens={apiTokens}
            setApiTokens={setApiTokens}
            definitionId={releaseDetectionSetting.definitionId}
            id={releaseDetectionSetting.id}
            definitionLevel={releaseDetectionSetting.definitionLevel}
            entityId={entityId}
            entityType={entityType}
            toggleModal={toggleModal}
            isApiTokensEnabled={isApiTokensEnabled}
            isReportedRelease={
              releaseDetectionSetting.name ===
                SettingValues.RELEASES_STRATEGY &&
              (_.get(releaseDetectionSetting, 'value.key') ===
                RELEASES_STRATEGY_REPORTED ||
                isCustomRelease)
            }
          />
        ))}

      {settings
        .filter(({ name }) => name !== SettingValues.RELEASES_STRATEGY)
        .filter(filterSettingByFF)
        .map(setting =>
          getSettingInputComponent(
            { ...setting, disabled: getIsSettingDisabled(setting) },
            {
              isReportedRelease:
                setting.name === SettingValues.RELEASES_STRATEGY &&
                (_.get(setting, 'value.key') === RELEASES_STRATEGY_REPORTED ||
                  isCustomRelease),
              entityId,
              entityType,
              toggleModal
            }
          )
        )}

      {isPmIssueTagsFetchStrategyEnabled && <PmIssueTagsFetchStrategy />}
    </Flex>
  );
};

export default withErrorBoundary(Settings, 'Advanced Settings');
